/**
 * store-as-a-router
 */

import { ReduceStore } from 'flux/utils';

import dispatcher from '../dispatcher';

// route constants
export const SPLASH = 'SPLASH';
export const INTRO = 'INTRO';
export const READMORE = 'READMORE';
export const SETTINGS = 'SETTINGS';
export const APP = 'APP';
export const DRINKS = 'DRINKS';
export const CALCULATOR = 'CALCULATOR';


const INITIAL_STATE = {
  route: DRINKS,
};

class RouteStore extends ReduceStore {
  getInitialState() {
    return {
      ...INITIAL_STATE,
    };
  }
  reduce(state, action) {
    const { type, data } = action;

    switch (type) {
      case 'NAVIGATE':
        return {
          route: data,
        };

      case 'ADD_DRINK':
        return {
          route: DRINKS,
        };

      case 'RESET_APP':
        return this.getInitialState();

      default:
        return state;
    }
  }
}

export default new RouteStore(dispatcher);



// WEBPACK FOOTER //
// ./src/stores/route.js